import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import jwtDecode from 'jwt-decode';
var decodedToken = function decodedToken() {
  return jwtDecode(localStorage.getItem('MDM_ACCESS_TOKEN'));
};
var isValidToken = function isValidToken() {
  if (!hasToken()) return false;
  var _decodedToken = decodedToken(),
    exp = _decodedToken.exp;
  return !!(localStorage.getItem('MDM_ACCESS_TOKEN') && new Date().getTime() < exp * 1000);
};
var hasApiAudience = function hasApiAudience(_ref) {
  var apiName = _ref.apiName;
  var _decodedToken2 = decodedToken(),
    aud = _decodedToken2.aud;
  return Array.isArray(aud) && aud.includes(apiName) || aud === apiName;
};
var hasToken = function hasToken() {
  return !!localStorage.getItem('MDM_ACCESS_TOKEN');
};
export { isValidToken, hasApiAudience, decodedToken, hasToken };